module.exports = __webpack_public_path__ + "img/no_journey_illustration.98a40115.svg";